import magnifiAPIInstance from "./apiInstance";

export const webStoryTemplateAPIs = {
  getWebstoryTemplates: ({ payload }) => magnifiAPIInstance.post(`/get-story-templates`, payload),
  deleteWebStoryTemplates: ({ payload }) => magnifiAPIInstance.post(`/delete-story-template`, payload),
  uploadStoryTemplate: ({ payload }) => magnifiAPIInstance.post(`/upload-story-template`, payload),
  moveStoryTemplate: ({ payload }) => magnifiAPIInstance.post(`/move-story-template`, payload),
  testStoryTemplate: ({ payload }) => magnifiAPIInstance.post(`/test-story-template`, payload),
};
